/**
 * @file: master-column.tsx
 *
 * Desktop column 1 — the inbox thread list. Selection is driven through the
 * inbox context (`activeThread$`), so this is just the framed home surface.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { InboxMobileLayout } from '../mobile-layout';

export const MasterColumn: FC = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        width: rpx(375),
        borderRightWidth: StyleSheet.hairlineWidth,
        borderRightColor: '#ececec',
        backgroundColor: '#fff',
      }}
    >
      <InboxMobileLayout />
    </View>
  );
});
